// Keep the complete request stable when a committed response is lost.
export class SupportSubmission<T extends Record<string, unknown>> {
  private attempt: { key: string; payload: T & { submission_id: string; page_url: string; user_agent: string } } | null = null;
  private inFlight = false;

  begin() {
    if (this.inFlight) return false;
    this.inFlight = true;
    return true;
  }

  end() { this.inFlight = false; }

  payloadFor(values: T, context: { page_url: string; user_agent: string }, makeId: () => string = () => crypto.randomUUID()) {
    const key = JSON.stringify(values);
    if (this.attempt?.key === key) return this.attempt.payload;
    const payload = { ...values, ...context, submission_id: makeId() };
    this.attempt = { key, payload };
    return payload;
  }
}
